import { render, staticRenderFns } from "./teaTraining.vue?vue&type=template&id=88e056c0"
import script from "./teaTraining.vue?vue&type=script&lang=js"
export * from "./teaTraining.vue?vue&type=script&lang=js"
import style0 from "./teaTraining.vue?vue&type=style&index=0&id=88e056c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports